import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from './../../../environments/environment';
import { Injectable, inject, provideAppInitializer } from '@angular/core';
import * as _ from 'lodash';
import { EcaWindowRefService } from '../window-ref/window-ref.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EcaEnvironmentService {
  private http = inject(HttpClient);
  private windowRefService = inject(EcaWindowRefService);


  json: object = {};
  private loadQ: Promise<any>;

  public load(env = environment, force = false): Promise<any> {
    const configJsonUrl = env.configJsonUrl;
    const loadRemote: boolean = !!env.configJsonUrl;
    const console = this.windowRefService.nativeWindow.console;

    this.json = _.cloneDeep(env);

    if (force) {
      this.loadQ = null;
    }

    return this.loadQ = this.loadQ || new Promise((resolve: (value: void) => void, reject) => {
      if (loadRemote) {
        this.http.get(configJsonUrl)
        .pipe(
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          catchError(error => {
            console.log('no config.json found');
            return observableThrowError('Server error');
          })
        )
        .subscribe({
          next: response => {
            this.json = Object.assign({}, this.json, response);
            resolve();
          },
          error: error => {
            reject(error);
          }
        });
      } else {
        resolve();
      }
    }).then(() => this.json);
  }
}

export function loadEnvironmentFactory (ecaEnvironmentService: EcaEnvironmentService) {
  return () => ecaEnvironmentService.load();
}

export const ECA_ENVIRONMENT_APP_INITIALIZER_PROVIDER = provideAppInitializer(() => {
        const initializerFn = (loadEnvironmentFactory)(inject(EcaEnvironmentService));
        return initializerFn();
      });
